import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import responderExigenciaSelector from "../store/responderExigencia.selectors";
import responderExigenciaActions from "../store/responderExigencia.actions";
import autoBind from "react-autobind";
import StaticGrid from "@common/components/grid/staticGrid.component";
import * as typeArray from "@/modules/common/app/helpers/grid.typeArray";
import ModalExigencia from '../container/responderExigencia.modal';
import Form from "@common/externos/components/validation/form.validation";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "RedeSIM.ResponderExigencia",
      applySearchOnLoad: true,
      isNotCheckable: true,
    };

    const columns = [
      {
        fieldName: "Análise",
        dataName: "IdAnalise",
        show: true,
        type: "number",
        isLong: true,
        removeFilter: true,
        width: 100
      },
      {
        fieldName: "É Documento",
        dataName: "ExigenciaDocumento",
        show: true,
        array: typeArray.tipoSimNaoInt,
        type: "lista",
        arrayType: "number",
        removeFilter: true,
        width: 100
      },
      {
        fieldName: "Documento",
        dataName: "TipoDocumento",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Exigência",
        dataName: "Exigencia",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Motivo",
        dataName: "Motivo",
        show: true,
        type: "text",
        removeFilter: true
      },
    ];

    const actions = [
      {
        title: "Responder Exigência",
        icon: "fas fa-file-alt",
        onClick: async dataItem => {
          this.props.responderExigenciaActions.setFormExigencia(dataItem);
          this.props.responderExigenciaActions.setShowGridExigencia(false);
        }
      },
      {
        type: 'view',
        icon: 'far fa-eye',
        title: 'Visualizar Documento, Exigência e Motivo',
        onClick: dataItem => {
          this.props.responderExigenciaActions.setModalExigencia(dataItem);
          this.props.responderExigenciaActions.toggleExigenciaModal();
        },
      },
    ];

    const order = [
      { fieldName: "Análise", dataName: "IdAnalise", order: "A" }
    ];

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      }
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar
    };
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "redeSIM.responderExigencia" });
  }

  render() {
    const { responderExigencia } = this.props.responderExigenciaSelector;
    const { DataGridExigencia } = responderExigencia;

    return (
      <Fragment>
        <ModalExigencia />
        <Form
          onCancel={this.onCancel}
          isView={true}
        >
        {form => (
          <StaticGrid {...this.config} itens={DataGridExigencia.asMutable()}></StaticGrid>
        )}
        </Form>
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    responderExigenciaActions
  },
  selectors: {
    responderExigenciaSelector
  }
})(Container);
